import React from "react";
import { TextField, Box } from "@mui/material";

const OTPInput = ({otp, setOtp, length = 6, onComplete, fontSize = "14px", boxWidth = "18px" }) => {
  // const [otp, setOtp] = useState(new Array(length).fill(""));

  const handleChange = (event, index) => {
    const value = event.target.value;
    if (!/^[0-9]?$/.test(value)) return; // Allow only digits

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to the next box automatically
    if (value && index < length - 1) {
      document.getElementById(`otp-${index + 1}`).focus();
    }

    // Trigger callback when OTP is complete
    if (newOtp.every((digit) => digit !== "") && typeof onComplete === "function") {
      onComplete(newOtp.join(""));
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  return (
    <Box marginY={1} display="flex" gap={1} justifyContent="center">
      {otp.map((digit, index) => (
        <TextField
          key={index}
          id={`otp-${index}`}
          type="text"
          variant="outlined"
          inputProps={{
            maxLength: 1,
            style: { textAlign: "center", fontSize: fontSize, width: boxWidth },
          }}
          value={digit}
          onChange={(event) => handleChange(event, index)}
          onKeyDown={(event) => handleKeyDown(event, index)}
        />
      ))}
    </Box>
  );
};

export default OTPInput;
